module.exports = __webpack_public_path__ + "images/395fc96765ae3a0992430af60cba0374.png";